// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__IUiXc","content":"ManualTimeModal_content__3Mpkz"};